import React from "react";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import BaseQuoteTabShow
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseQuoteTabShow/BaseQuoteTabShow";

export default function ProspectQuotesCustomTabShow(props) {
    const { currentRoute } = useNavigation();

    return (
        <BaseQuoteTabShow
            {...props}
            fetchFormParameters={{ tabId: currentRoute.route.metadata.tab_id }}
        />
    )
}
